export enum CreateFromTemplateActionTypes {
  CREATED_FROM_TEMPLATE = 'set-cards/CREATED_FROM_TEMPLATE',
  CREATING_FROM_TEMPLATE = 'set-cards/CREATING_FROM_TEMPLATE',
}
